import LegalLayout from "./LegalLayout";
import { Mail, MessageSquareText, Building2 } from "lucide-react";

export default function Contact() {
  return (
    <LegalLayout
      testid="page-contact"
      eyebrow="Contact"
      title="Get in touch."
    >
      <p className="text-lg text-white/85">
        The fastest way to reach us is email. We typically reply within one working day, often sooner.
      </p>

      <div className="grid sm:grid-cols-2 gap-4 not-prose my-10">
        <a href="mailto:hello@instavibe.co.uk" className="surface-card p-6 hover:border-klein/50 transition-colors block" data-testid="contact-card-general">
          <Mail className="w-5 h-5 text-klein mb-3" strokeWidth={1.5} />
          <div className="font-heading font-bold text-lg mb-1">General &amp; sales</div>
          <div className="text-sm text-white/60 mb-3">Questions about features, pricing, or your account.</div>
          <div className="font-mono text-sm text-cyan break-all">hello@instavibe.co.uk</div>
        </a>

        <a href="mailto:support@instavibe.co.uk" className="surface-card p-6 hover:border-klein/50 transition-colors block" data-testid="contact-card-support">
          <MessageSquareText className="w-5 h-5 text-klein mb-3" strokeWidth={1.5} />
          <div className="font-heading font-bold text-lg mb-1">Technical support</div>
          <div className="text-sm text-white/60 mb-3">Webhook issues, Meta connection trouble, billing.</div>
          <div className="font-mono text-sm text-cyan break-all">support@instavibe.co.uk</div>
        </a>

        <a href="mailto:privacy@instavibe.co.uk" className="surface-card p-6 hover:border-klein/50 transition-colors block" data-testid="contact-card-privacy">
          <Mail className="w-5 h-5 text-klein mb-3" strokeWidth={1.5} />
          <div className="font-heading font-bold text-lg mb-1">Privacy &amp; data</div>
          <div className="text-sm text-white/60 mb-3">Data subject access requests, deletion, GDPR.</div>
          <div className="font-mono text-sm text-cyan break-all">privacy@instavibe.co.uk</div>
        </a>

        <div className="surface-card p-6" data-testid="contact-card-address">
          <Building2 className="w-5 h-5 text-klein mb-3" strokeWidth={1.5} />
          <div className="font-heading font-bold text-lg mb-1">Postal address</div>
          <div className="text-sm text-white/60 mb-3">For formal correspondence only.</div>
          <div className="font-mono text-sm text-white/80 leading-relaxed">InstaVibe<br/>Paisley<br/>Scotland, UK</div>
        </div>
      </div>

      <h2 className="font-heading font-bold text-2xl text-white mt-10 mb-3">Before you email us</h2>
      <p>If your Instagram connection or auto-replies aren't working, please first check the Webhook Activity panel in the Admin area, then send us the event ID and the error message — that lets us diagnose 90% of issues without back-and-forth.</p>
    </LegalLayout>
  );
}
